import StackKit from "@/shared/components/kit/stack";
import { Grid, TextField, Skeleton } from "@mui/material";
import TableWallet from "../walletReports/table";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import CustomButton from "@/shared/components/kit/button";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import BoxKit from "@/shared/components/kit/box";
import { MapgisheDaum } from "@/types/api/user/home.type.data";
import CardBoxLayout from "../../layout/cardBoxLayout";
import { useNavigate } from "react-router";
/**
 * Content
 *
 * نمایش لیست مراکز گیشه به همراه قابلیت جستجو.
 *
 * - دریافت داده‌های مراکز از props `dataLocation`.
 * - فیلتر مراکز با نوع "gishe" و تبدیل آدرس‌ها به رندر شامل آیکون موقعیت.
 * - شامل بخش هدر با عنوان "گیشه" و فیلد جستجو.
 * - نمایش جدول با استفاده از `TableWallet`.
 * - در صورت عدم وجود داده، نمایش Skeleton Loader برای جایگزینی محتوا.
 *
 * @param dataLocation Array<MapgisheDaum> | undefined داده مراکز گیشه
 * @returns JSX.Element
 */

const Content = ({dataLocation,}: {dataLocation: MapgisheDaum[] | undefined;}) => {
  const navigate = useNavigate();

  const dataHeader = [
    { id: "merchant_name", title: "نام مرکز" },
    { id: "amount", title: "استان مرکز" },
    { id: "test", title: "شهر مرکز" },
    { id: "address", title: "آدرس " },
  ];

  const handleLocationClick = (lat: number | string,lon: number | string,name: string) => {
    navigate(`/locations/map?lat=${lat}&lon=${lon}&name=${name}`);
  };

  const newDataLocationDetail = dataLocation ?.filter((item) => item.type === "gishe").map((item, index: number) => ({...item, address: (
        <StackKit direction={"row"} alignItems={"center"} justifyContent={"space-between"} sx={{ minWidth: "200px" }}>
          <TypoGraphyKit variant="body1" sx={{ maxWidth: "300px", textOverflow: "ellipsis", overflow: "hidden",}}>
            {item.address}
          </TypoGraphyKit>
          <StackKit onClick={() => handleLocationClick(item.latitude,item.longitude,item.merchant_name)}>
            <LocationOnOutlinedIcon />
          </StackKit>
        </StackKit>
      ),
    })
  );

  const fakeData = newDataLocationDetail;

  return (
    <CardBoxLayout>
      <Grid container spacing={2}>
        {/* Header & Search Bar */}
        <StackKit className="w-full" direction={{ xs: "column", sm: "row" }} justifyContent={{ xs: "center", sm: "space-between" }} alignItems={{ xs: "stretch", sm: "center" }} sx={{ paddingX: "16px",paddingTop:'16px', gap:2 }}>
          {/* Title */}
          <TypoGraphyKit variant="h6" sx={{ textAlign: { xs: "center", sm: "left" } }}>
            گیشه
          </TypoGraphyKit>
        </StackKit>

        {/* Table or Skeleton Loader */}
        <>
          {fakeData && fakeData.length > 0 ? (
            <TableWallet dataHeader={dataHeader} dataTbody={fakeData} />
          ) : (
            <StackKit sx={{ padding: "20px" }} spacing={2}>
              {Array.from({ length: 5 }).map((_, i) => (
                <Skeleton key={i} variant="rectangular" height={40} />
              ))}
            </StackKit>
          )}
        </>
      </Grid>
    </CardBoxLayout>

  );
};

export default Content;
